<template>
  <div
    v-if="!isLoading"
    id="app"
    class="p-1"
    :style="{ backgroundImage: `url(${backgroundImage ? backgroundImage : require(`@/assets/img/bg.jpg`)})` }"
  >
    <transition
      name="slither"
      appear
      mode="out-in"
      @after-leave="afterLeave"
    >
      <router-view />
    </transition>
  </div>
</template>
<script>
import * as Sentry from '@sentry/browser';
import { mapActions } from 'vuex';

export default {
  name: 'App',
  data() {
    return {
      isLoading: false,
      backgroundImage: null,
    };
  },
  async created() {
    try {
      this.isLoading = true;
      this.backgroundImage = await this.fetchAppBackground();
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    ...mapActions('layout', ['fetchAppBackground']),

    afterLeave() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style lang="scss">
[v-cloak] {
  display: none;
}

#app {
  font-family: 'Open Sans';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-size: cover;
  background-attachment: fixed;
  min-height: 100vh;
  background-position: bottom;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.slither-enter-active, .slither-leave-active {
  transition: transform 0.65s;
}

.slither-enter, .slither-leave-to {
  transform: translateX(-100%);
}

.slither-enter-to, .slither-leave {
  transform: translateX(0);
}
</style>
